{
  "account_created_sign_in_required": "Your account was created. Please sign in to continue.",
  "logout_error": "Unable to sign out. Please try again.",
  "secure_booking": "To secure your booking at <strong>{{venue}}</strong> we need to verify your card details for <strong>{{amount}}</strong>. No money will be taken unless you fail to turn up for your booking or break the booking terms.<br />Please provide your card details using the secure form below.",
  "details": "Details",
  "pre_order": "Pre-Order",
  "pay": "Pay",
  "time": "Time",
  "date": "Date",
  "already_paid": "This booking is already fully paid.",
  "no_further_payment": "No further payment is required.",
  "booking_cancelled": "This booking has been cancelled.",
  "booking_cancelled_no_payment": "No payment is required.",
  "loading": "Loading...",
  "cookie_preferences": "Cookie preferences",
  "payment_success": "Payment successful!",
  "payment_error": "Failed to process payment. Please try again.",
  "payment_requested": "A payment of <strong>{{amount}}</strong> has been requested by <strong>{{venue}}</strong> in order to secure your booking on <strong>{{date}}</strong>. Please make this payment using the secure form below.",
  "pre_orders_title": "Pre-orders Menu",
  "add_dietary_requirements": "Add allergens and dietary requirements",
  "pre_order_kcal_info": "Adults require around 2000 kcal a day",
  "item_calories": "({{calories}}kcal)",
  "pre_order_offers_info": "Take advantage of our pre-order offers!",
  "basket_item_update_failed": "Sorry, we couldn't update this basket item. Please try again.",
  "dietary_requirements_save_failed": "Sorry, we couldn't save your dietary requirements. Please try again.",
  "service_charge_update_failed": "Sorry, we couldn't update the service charge. Please try again.",
  "enter_dietary_requirements": "Enter dietary requirements...",
  "close": "Close",
  "diet_types": ["Vegetarian", "Vegan", "Dairy free", "Halal", "Kosher", "Low fat", "Gluten free"],
  "allergens": [
    "Gluten",
    "Wheat",
    "Peanuts",
    "Nuts",
    "Milk",
    "Soy",
    "Fish",
    "Celery",
    "Mustard",
    "Crustaceans",
    "Eggs",
    "Lupin",
    "Molluscs",
    "Sesame seeds",
    "Sulphur dioxide"
  ],
  "discount_description": "Order {{quantity}} or more for {{amount}} off.",
  "booking_reference": "Booking reference",
  "widget_booking_reference": "Booking Reference",
  "noBookingData": "No booking data available.",
  "add_notes_about_order": "Add notes about your order.",
  "select_diet_types": "Select any diet types that apply",
  "select_allergies": "Select any allergies that apply",
  "done": "Done",
  "Dietary:": "Dietary:",
  "Allergens:": "Allergens:",
  "contains_allergen_for_name": "Contains allergens {{name}} has listed",
  "contains_your_allergen": "Contains allergens you have listed",
  "Decrease amount": "Decrease amount",
  "decrease_amount_for": "Decrease amount for {{name}}",
  "Amount for": "Amount for",
  "Increase amount": "Increase amount",
  "increase_amount_for": "Increase amount for {{name}}",
  "update_preorder_error": "Failed to update item quantity. Please try again.",
  "update_item_error": "Failed to add item. Please try again.",
  "configurable_options_error": "Please fix the following issues:",
  "configurable_options_confirm_error": "Failed to update item. Please try again.",
  "payment_method": "Payment method",
  "transaction_declined": "Transaction declined. Please try again.",
  "confirm_billing_address": "Confirm your billing address:",
  "first_name": "First Name",
  "last_name": "Last Name",
  "email": "Email",
  "mobile_phone": "Mobile Number",
  "address": "Address",
  "country": "Country",
  "city": "City",
  "postal_code": "Postal Code",
  "select_country": "Select Country",
  "confirm": "Confirm",
  "debit_credit_card": "Debit / Credit Card",
  "apple_pay": "Apple Pay",
  "google_pay": "Google Pay",
  "field_required": "This field is required",
  "letters_only": "Must contain only letters",
  "name_required": "Name is required",
  "email_required": "Email is required",
  "invalid_email": "Please enter a valid email address",
  "mobile_phone_required": "Mobile Number is required",
  "mobile_phone_format": "Mobile Number must include a country code starting with + and a maximum of 15 digits",
  "mobile_phone_invalid": "Please enter a valid mobile number",
  "mobile_phone_invalid_example": "Please enter a valid mobile number, for example {{example}}",
  "phone_country_code": "Country code",
  "phone_country_search": "Search countries",
  "phone_country_no_results": "No countries found",
  "person_already_in_list": "That person is already in the list",
  "max_names_for_guests_reached": "You've added a name for every guest in your booking",
  "names_exceed_guests": "You have more names than guests in your booking. Please remove the names you no longer need.",
  "ordering_for_multiple_people": "Order for multiple people",
  "multiple_names_info": "You can add names and order for each person.",
  "add_name_placeholder": "Who's ordering?",
  "add_button": "Add",
  "person_number": "Person {{number}}",
  "name_save_failed": "Sorry, we couldn't save this name. Please try again.",
  "select_person": "Select person:",
  "unassigned": "Unassigned",
  "item": "item",
  "items": "items",
  "options_for": "Options for {{itemName}}",
  "configurable_options": "Configurable Options",
  "option_number": "Option {{number}}",
  "required_select_exact_option": "Required. Select exactly {{count}} option.",
  "required_select_exact_options": "Required. Select exactly {{count}} options.",
  "required_select_between_options": "Required. Select between {{min}} and {{max}} options.",
  "required_select_at_least_option": "Required. Select at least {{min}} option.",
  "required_select_at_least_options": "Required. Select at least {{min}} options.",
  "optional_select_up_to_option": "Select up to {{max}} option. (Optional)",
  "optional_select_up_to_options": "Select up to {{max}} options. (Optional)",
  "optional_select_any_options": "Optional. Select any that apply.",
  "please_review_option_selections": "Please review your option selections to proceed",
  "select_at_least": "Please select at least {{min}} option{{plural}}.",
  "edit_person": "Edit this person",

  "place_order_button": "Place Order",
  "linked_booking_section_title": "Select your {{bookingTypeName}} order",
  "linked_booking_section_description": "Select your {{bookingTypeName}} items which will be added to your basket and then select {{nextBookingTypeName}} items",
  "linked_booking_section_description_last": "Select your {{bookingTypeName}} items which will be added to your basket. When you are happy with your basket click the {{placeOrderLabel}} button to confirm your order.",
  "linked_booking_no_menus": "No menus available for this booking type",
  "total_label": "Total",
  "inc_vat": "inc {{taxLabel}}",
  "net_label": "Net",
  "tax_total_label": "Total",
  "payment_error_generic": "Something went wrong with your payment. Please try again.",
  "failed_load_payment_config": "Failed to load payment configuration.",
  "failed_initialize_payment": "Failed to initialize payment. Please try again.",
  "manage_order_title": "Manage Your Order",
  "manage_order_subtitle": "Add items to your pre-order using the button below, then return here to review and complete.",
  "pending_orders": "Orders Placed",
  "no_orders_found": "No orders added yet.",
  "order_status_pending": "Pending",
  "order_status_complete": "Complete",
  "order_status_deleted": "Deleted",
  "payment_ref": "Payment Ref",
  "paid": "Total paid",
  "edit": "Edit",
  "delete": "Delete",
  "for": "For",
  "service_charge": "Service Charge",
  "discretionary_service_charge": "Discretionary service charge",
  "order_notes": "Order notes",
  "order_notes_label": "Notes:",
  "order_has_dietary_info": "This order has notes or dietary requirements",
  "order_summary": "Order Summary",
  "subtotal": "Subtotal",
  "discount": "Discount",
  "total": "Total",
  "payment_required": "Payment Required",
  "payment_now_required": "To complete your order, a payment of {{amount}} will be required.",
  "payment_now_required_confirm": "A payment of <strong>{{amount}}</strong> is now required, which you can make securely below.",
  "pay_now": "Pay now",
  "complete_preorder": "Complete Pre-order",
  "complete_preorder_disabled_help": "Please ensure you have pending orders to complete.",
  "payment_details": "Payment Details",
  "amount_to_pay": "Amount to Pay",
  "back": "Back",
  "booking_details": "Booking Details",
  "venue": "Venue",
  "booking_ref": "Booking Ref",
  "guests": "Guests",
  "completed": "Completed",
  "confirm_delete_order": "Are you sure you want to delete this order?",
  "retry": "Retry",
  "recaptcha_not_loaded": "Google reCAPTCHA not loaded",
  "invalid_captcha_token": "Invalid captcha token received",
  "your_name": "Your Name",
  "email_address": "Email Address",
  "confirm_your_details": "Confirm Your Details",
  "confirm_details_instruction": "Please confirm your name and email to continue.",
  "no_items_selected": "No items are selected",
  "order_success": "Thank you, we have received your order and a payment of <strong>{{amount}}</strong> has been taken. Confirmation of this order has also been sent to {{email}}. If you are the lead booker please go back to the Manage Your Order page to let the venue know when your pre-order is complete.",
  "order_success_hide_price": "Thank you, we have received your order. Confirmation of this order has also been sent to {{email}}. If you are the lead booker please go back to the Manage Your Order page to let the venue know when your pre-order is complete.",
  "order_success_booking_journey": "Thank you, we have received your order and a payment of <strong>{{amount}}</strong> has been taken.",
  "page_not_found": "Page Not Found",
  "payment_timeout_title": "Payment Taking Too Long",
  "request_slow_message": "This is taking longer than expected. Please bear with us…",
  "booking_unconfirmed_message": "We couldn't confirm your booking. Please check your email for a booking confirmation before trying again. If you haven't received one within 10 minutes, please get in touch with the venue directly.",
  "payment_timeout_message": "We are still confirming your payment. Please do not pay again as this could result in a duplicate charge. Check your email for a confirmation and if nothing arrives within 10 minutes, get in touch with the venue directly.",
  "preorder_limited_message_min_max": "You currently have {{currentItems}} items in your {{menuName}} order. This menu requires between {{minItems}} and {{maxItems}} items. Please add {{neededItems}} more item(s) to meet the minimum requirement.",
  "preorder_limited_message_min": "You currently have {{currentItems}} items in your {{menuName}} order. This menu requires a minimum of {{minItems}} items. Please add {{neededItems}} more item(s) to meet the minimum requirement.",
  "preorder_update_failed": "Sorry, we could not update your order. Please try again or contact the venue.",
  "preorder_save_failed": "Sorry, we could not save your order. Please try again or contact the venue.",
  "reload_page": "Reload the page",
  "pre_order_items": "Pre-Order Items",
  "booking_confirmation_modal_label": "Booking confirmation",
  "booking_confirmed_title": "Booking Confirmed!",
  "order_confirmed_title": "Order Confirmed!",
  "payment_confirmed_title": "Payment Confirmed!",
  "booking_confirmed_message": "Thank you for your payment. Your table reservation at {{venue}} has been successfully confirmed.",
  "booking_thank_you_booking_with_preorders": "Thank you for your payment and pre-order. Your table reservation at {{venue}} has been successfully confirmed.",
  "booking_with_preorders_confirmed_message": "Your pre-order items have been received and will be ready for your visit.",
  "success_message": "Thank you for your payment.",
  "success_message_order": "Thank you for your order.",
  "booking_reference_label": "Booking reference:",
  "payment_successful_title": "Payment Successful",
  "payment_successful_message_auth": "Your card has been authenticated for a payment of <strong>{{amount}}</strong>, but no money has been taken at this time. You can now safely close this window.",
  "payment_successful_message_payment": "We have successfully processed your payment of <strong>{{amount}}</strong>. You can now safely close this window.",
  "payment_confirmation_email_notice": "A confirmation email will be sent to you shortly.",
  "booking_details_title": "Your Booking Details",
  "booking_details_party_size": "Party Size",
  "booking_details_guest": "guest",
  "booking_details_guests": "guests",
  "booking_covers_guest": "Guest",
  "booking_covers_guests": "Guests",
  "booking_details_date": "Date",
  "booking_details_time": "Time",
  "booking_details_location": "Location",
  "booking_details_preorder_title": "Pre-ordered Items",
  "whats_next_title": "What's Next?",
  "whats_next_email_title": "Confirmation Email:",
  "whats_next_email_message": "You'll receive a detailed confirmation email within the next few minutes with your booking reference and receipt.",
  "whats_next_arrival_title": "Arrival Instructions:",
  "whats_next_arrival_message": "Please arrive 10 minutes before your reservation time. Present your booking confirmation to the host.",
  "whats_next_changes_title": "Need Changes?",
  "whats_next_changes_message": "Contact us at least 24 hours before your booking to make any modifications.",
  "error": "Error",
  "missing_booking_id": "Missing booking ID",
  "waiting_payment_confirmation": "Waiting for payment confirmation...",
  "please_wait_confirm_payment": "Please wait while we confirm your payment...",
  "payment_received_title": "Payment Received",
  "payment_received_without_details": "We have received your payment for your booking.",
  "card_authenticated_title": "Card Authenticated",
  "card_authenticated_without_details": "Your card has been authenticated for your booking, but no money has been taken at this time.",
  "order_received": "Order Received",
  "preorder_complete_no_payment": "Thank you, your pre-orders are now complete. A confirmation of your pre-orders has also been emailed to you.",
  "preorder_complete_with_payment": "Thank you, your pre-orders are now complete and a payment of <strong>{{amount}}</strong> has been taken. A confirmation of your pre-orders has also been emailed to you.",
  "bookings_close_on_date": "Pre-orders close on {{date}}.",
  "preorders_marked_complete": "Preorders for this booking have been completed.",
  "preorders_closed": "Pre-orders for this booking are now closed.",
  "preorders_unavailable": "Pre-orders for this booking are currently unavailable.",
  "preorder_unavailable_not_eligible": "Pre-orders are not available for this booking.",
  "preorder_unavailable_order_not_editable": "This order can no longer be edited.",
  "preorder_unavailable_limit_reached": "The set number of pre-orders for this booking has been reached. Please contact the venue if you would like to increase your party size.",
  "booking_past_no_preorders": "This booking has already taken place, so no more pre-orders can be added.",
  "orders_added_to_booking": "The following orders have been added to your booking:",
  "min_group_member_orders_not_met": "The minimum required number of group orders has not been reached.",
  "no_items": "No items have been ordered yet.",
  "edit_order": "Edit order",
  "payment_none_alert_message": "Payment will be taken at the venue. Review your orders above before completing",
  "payment_group_members_paid": "Your group members have paid for their items. Review all orders above before completing",
  "place_pre_order": "Place Pre-Order",
  "payment_required_alert_message": "Pay {{amount}} now to complete your order. The remaining balance will be collected at the venue.",
  "paid_amount": "Already paid",
  "total_due": "Total due",
  "none_and_group_members_pay_alert": "The remaining balance will be collected at the venue",
  "group_and_lead_pay_alert_message": "A payment of {{amount}} is required to complete the remaining orders",
  "booking_missing_venue_id": "A venue ID is required to make a booking.",
  "booking_stage_initial": "Step 1: Select your booking details",
  "booking_stage_details": "Step 2: Enter your details",
  "booking_stage_preorders": "Step 3: Pre-order food and drinks",
  "booking_stage_payment": "Step 4: Complete payment",
  "booking_stage_complete": "Booking complete",
  "enquiry_stage_details": "Step 2: Enter your details for your enquiry",
  "enquiry_stage_complete": "Enquiry complete",
  "booking_submit_enquiry": "Submit Enquiry",

  "booking_step_details": "Details",
  "booking_step_preorders": "Pre-order",
  "booking_step_payment": "Payment",
  "booking_step_of": "Step {{current}} of {{total}}",

  "booking_type": "Booking Type",
  "booking_date": "Date",
  "booking_quick_date_select": "Quick date selection",
  "booking_today": "Today",
  "booking_tomorrow": "Tomorrow",
  "booking_guests_date_title": "Book and Enquire",
  "booking_choose_type_title": "Choose Booking Type",
  "booking_choose_type_title_widget": "Select Booking Type",
  "booking_time_title_widget": "Select Your Time",
  "booking_select_venue_title": "Select a Venue",
  "booking_venue_search_placeholder": "Search venues...",
  "booking_venue_search_no_results": "No venues match your search.",
  "booking_venues_loading": "Loading venues...",
  "booking_venues_error": "Failed to load venues. Please try again.",
  "booking_back": "Back",
  "booking_change": "Change",
  "booking_no_times_available": "No times available for this selection.",
  "booking_time": "Start Time",
  "booking_select_time": "Select a time",
  "booking_time_expired_notice": "Your session has timed out. Please <restart>re-start your booking</restart>.",
  "booking_covers": "Number of Guests",
  "booking_until": "End Time",
  "booking_select_until": "Select end time",
  "booking_until_close": "Close",
  "booking_duration_until_close": "Until close",
  "booking_until_info": "Bookings are {{duration}}. Contact us to request longer.",
  "duration_minute_one": "minute",
  "duration_minute_other": "minutes",
  "duration_hour_one": "hour",
  "duration_hour_other": "hours",
  "booking_next": "Next",

  "booking_availability_accepted_title": "Your time is available",
  "booking_availability_accepted": "Good news — your selected time is available. Continue to add your details.",
  "booking_availability_rejected_title": "That time is unavailable",
  "booking_availability_rejected": "We cannot confirm this time online. You can send the venue an enquiry or change your booking details.",
  "booking_availability_unavailable_title": "Choose another booking option",
  "booking_availability_unavailable": "Your selected time is unavailable. Choose another available time or send the venue an enquiry.",
  "booking_alternative_times": "Alternative Times",
  "booking_alternative_venues": "Alternative Venues",
  "booking_enquiry_instead": "Submit an enquiry instead",
  "booking_availability_may_enquire_title": "The venue may still be able to help",
  "booking_availability_may_enquire": "We cannot confirm this time instantly, but the venue may still be able to accommodate you. Continue to send an enquiry or change your details.",
  "booking_availability_enquiry_title": "Your booking will be an enquiry",
  "booking_availability_enquiry_message": "This booking needs confirmation from the venue. Continue to send your enquiry, and the venue will contact you to confirm.",
  "booking_time_warning": "Bookings made less than 24 hours in advance may not be confirmed in time. Please contact the venue if your booking is urgent.",
  "booking_continue_as_enquiry": "Continue as enquiry",
  "booking_enquiry_alert": "You are making a {{bookingType}} booking enquiry for {{numPeople}} people at {{time}} on {{date}}",
  "booking_enquiry_for_time": "Enquire for this time",
  "booking_change_details": "Change details",
  "booking_select_time_slot": "Select time slot {{time}}",
  "booking_select_venue_time_slot": "Select {{time}} at {{venue}}",
  "booking_where_to_book": "Your booking at",

  "cross_sell_modal_title": "Sorry, time unavailable",
  "cross_sell_modal_description": "That time isn't available at {{venue}}. Pick from the times below, or make an enquiry about your original time.",
  "cross_sell_modal_your_selection": "Your selection",
  "cross_sell_modal_available_times": "Available Times",
  "cross_sell_modal_continue": "Continue with selected time",
  "cross_sell_modal_enquiry": "Make an enquiry for {{time}}",

  "booking_customer_details": "Your Details",
  "booking_special_requests": "Special Requests",
  "booking_dob": "Date of Birth",
  "booking_guest_list": "Guest Names",
  "booking_manage_guest_names": "Manage Guest Names ({{count}})",
  "booking_guest_names_done": "Done",
  "booking_guest_name": "Guest {{number}}",
  "booking_tags": "Additional Information",
  "booking_select_tag": "Select...",
  "booking_newsletter_signup": "Keep up to date with the hottest new openings, special offers and quirkiest spots by subscribing to DesignMyNight's emails.",
  "booking_newsletter_terms": "By checking the above box you agree to our <termsLink>terms and conditions</termsLink> and acknowledge our <privacyLink>privacy notice</privacyLink>. 18+ only.",
  "booking_terms_link_label": "terms and conditions",
  "booking_privacy_link_label": "privacy notice",
  "booking_marketing_preferences": "Marketing Preferences",

  "minimum_spend_requirement": "Minimum spend requirement",
  "booking_preorder_minimum_spend": "Minimum spend of {{amount}} required for {{menu}}.",

  "booking_deposit_title": "Secure Your Booking",
  "booking_payment_title": "Payment",
  "booking_payment_summary": "Payment Summary",
  "booking_deposit_amount": "Deposit",
  "booking_preorder_payment": "Pre-order Payment",
  "booking_preorder_payment_percentage": "Amount to pay now",
  "booking_preorder_total": "Total order amount",
  "booking_preorder_total_label": "Pre-order total",
  "booking_payment_auth_note": "Your card will be authenticated but no payment will be taken at this time.",
  "booking_card_validation_message": "To confirm your booking at {{venue}}, we need to authenticate your card for {{amount}}. No money will be taken at this time.",
  "booking_card_validation_auth_deposit_message": "Your card will be authenticated for {{amount}} to confirm your booking.",
  "booking_msg_pre_order_and_payment_required": "You will need to pre-order some items and pay for your chosen items in order to complete this booking.",
  "booking_msg_pre_order_and_deposit_required": "You will need to pre-order some items and pay a deposit for your chosen items in order to complete this booking.",
  "booking_msg_pre_order_required": "You will need to pre-order some items in order to complete this booking.",
  "booking_msg_payment_required": "To secure this booking, we will need to take a payment of {{amount}}.",
  "booking_msg_deposit_required": "To secure this booking, we will need to hold your card details for an amount of {{amount}}. We hold your card details, but no money will be taken unless you fail to turn up for your booking or break the booking terms.",
  "booking_msg_pre_order_or_deposit_required": "To secure this booking, you will either need to pre-order and pay for some items, or we will need to take a payment of {{amount}}.",
  "booking_msg_pre_order_or_auth_deposit_required": "To secure this booking, you will either need to pre-order and pay for some items, or we will need to hold your card details for a deposit of {{amount}}. If we hold your card details, no money will be taken unless you fail to turn up for your booking or violate the booking terms.",
  "booking_voucher_code": "Voucher Code",
  "booking_voucher_placeholder": "Enter your voucher code",
  "booking_voucher_apply": "Apply",
  "booking_voucher_remove": "Remove",
  "booking_voucher_remove_aria": "Remove voucher {{code}}",
  "booking_voucher_redeemed": "Voucher redeemed",
  "booking_voucher_amount_on_card": "Amount to pay on card",
  "booking_voucher_duplicate": "This voucher has already been applied.",
  "booking_voucher_invalid": "This voucher code is not valid.",
  "booking_voucher_invalid_restored": "Voucher {{code}} is no longer valid and has been removed.",
  "booking_voucher_some_invalid": "Some vouchers are no longer valid and have been removed.",
  "booking_voucher_validation_error": "Voucher validation failed. Please try again.",
  "booking_voucher_error": "We couldn't check that voucher. Please try again.",
  "booking_voucher_complete": "Complete booking",
  "booking_voucher_fully_redeemed_note": "Your vouchers cover the full amount, so there is nothing to pay on card.",
  "booking_payment_processor_area": "Payment form area",

  "booking_thank_you_booking": "Thank you for your booking!",
  "widget_booking_thank_you_booking": "Thank you for your booking",
  "booking_thank_you_enquiry": "Thank you for your enquiry!",
  "booking_only_confirmed_message": "Thanks! Your booking at {{venue}} is confirmed. You will receive confirmation by email shortly.",
  "booking_enquiry_received_message": "We have successfully received your booking enquiry and will get back to you as soon as possible. You will be contacted by our team shortly.",
  "booking_summary_auth_title": "Card Authenticated",
  "booking_summary_preorder_only": "Your pre-order has been added to your booking. A confirmation of your pre-order will be emailed to you shortly.",
  "booking_summary_preorder_payment": "Your pre-order has been added and we have successfully processed your payment of <strong>{{amount}}</strong>.",
  "booking_summary_preorder_auth": "Your pre-order has been added and your card has been authenticated for <strong>{{amount}}</strong>, but no money has been taken at this time.",
  "booking_detail_customer_name": "Name",
  "booking_detail_special_request": "Special Request",
  "booking_detail_requested_packages": "Requested Packages",
  "booking_detail_selected_offer": "Selected Offer",
  "booking_offer_save_failed": "We couldn't save your offer selection just now. Please check your connection and try again.",
  "booking_return_bind_failed": "We couldn't prepare your booking for payment just now. Please check your connection and try again.",
  "booking_deposit_paid": "Deposit Paid",
  "booking_redirecting": "Redirecting you back...",
  "booking_confirmation_rewards": "You will earn <strong>{{points}} points ({{pointsValue}})</strong> for attending this booking.",
  "booking_rewards_earn_attending": "Get free nights on us! Earn <strong>{{points}}</strong> ({{pointsValue}}) points for attending this booking.",
  "booking_rewards_earn_by_signing_up": "You can earn <strong>{{points}}</strong> ({{pointsValue}}) by signing up and attending this booking.",
  "booking_rewards_free_nights_out": "(Start earning <strong>FREE</strong> nights out!)",
  "booking_rewards_your_balance": "Your balance is <strong>{{balance}}</strong> ({{balanceValue}}).",
  "booking_rewards_your_balance_link": "Your balance is <strong>{{balance}}</strong> ({{balanceValue}}). Learn more here.",
  "booking_rewards_view_balance": "Check your balance, earn and spend!",
  "booking_rewards_signed_up": "Congratulations! You've just created an account with Design My Night. We've even chucked in a welcome bonus of <strong>{{balance}}</strong> ({{balanceValue}}) Reward Points. Once you hit {{minimumAmount}} points you'll have {{minimumValue}} to redeem against any event on DMN.",
  "booking_rewards_signed_up_no_balance": "Congratulations! You've just created an account with Design My Night. Once you hit {{minimumAmount}} points you'll have {{minimumValue}} to redeem against any event on DMN.",
  "booking_rewards_pending_note": "Points are added to your balance once you've attended.",

  "booking_points_banner": "Earn <strong>{{points}} points ({{pointsValue}})</strong> with this booking! Login or sign up after to claim.{{redeemMessage}}",
  "booking_points_redeem_message": " Collect {{amount}} points for {{value}} off ticketed events.",
  "booking_points_banner_logged_in": "Earn <strong>{{points}} points ({{pointsValue}})</strong> with this booking!{{redeemMessage}}",
  "booking_initial_rewards": "You will earn <strong>{{points}} points ({{pointsValue}})</strong> by making this booking.",
  "booking_rewards_can_redeem": "You have {{balance}} ({{balanceValue}}) points to redeem off your next purchase!",
  "booking_rewards_below_minimum": "You currently have {{balance}} ({{balanceValue}}) points. Once you hit {{minimumAmount}} points you'll have {{minimumValue}} to redeem against any ticketed event!",
  "booking_rewards_login_prompt": "Log in or sign up after booking to claim your reward points.",
  "booking_policy_title": "Booking Policy",
  "booking_policy_read_agree": "I have read and agree to the booking policy",
  "booking_confirm": "Confirm Booking",
  "booking_try_again": "Try Again",
  "session_expired_title": "Your session has expired",
  "session_expired_message": "Your session has timed out. Please re-start your booking.",
  "session_expired_restart": "Start again",
  "preorder_expiry_warning_message": "We’ll save your selected pre-orders for a further 2 hours. Please complete your selection soon to avoid re-ordering.",
  "preorder_cache_expired_basket": "Your pre-order selection has expired. Please re-add your items.",
  "session_retry_title": "Something went wrong",
  "session_retry_message": "We couldn't confirm your booking just now. Please check your connection and try again.",
  "yes": "Yes",
  "no": "No",

  "first_name_required": "Please enter your first name",
  "last_name_required": "Please enter your last name",
  "phone_required": "Please enter your phone number",
  "phone_format": "Phone number must include a country code starting with + and a maximum of 15 digits",
  "dob_day": "Day",
  "dob_month": "Month",
  "dob_year": "Year",
  "dob_required": "Please enter your date of birth",
  "booking_guest_number": "Guest {{number}}",
  "gender": "Gender",
  "select_gender": "Select...",
  "mandatory_tag_required": "Please complete all mandatory fields",
  "policy_required": "Please read the booking policy",

  "dmn_logo_link_label": "DesignMyNight",

  "unsupported_card_brand_title": "Card Not Supported",
  "unsupported_card_brand_message": "American Express (AMEX) cards are not accepted. Please use a Visa or Mastercard to complete your payment.",
  "amex_not_supported_notice": "Note: American Express (AMEX) cards are not supported. Please use a Visa or Mastercard.",
  "credit_card_disabled_notice": "Note: credit cards are not accepted for this type of booking. Please use a debit card.",
  "credit_card_disabled_title": "Credit Card Not Accepted",
  "credit_card_disabled_message": "Credit card payments have been disabled for this type of booking.",
  "retry_payment": "Try again with a different card",
  "payment_error_title": "Payment Issue",
  "payment_error_generic_message": "Something went wrong while processing your payment. No money has been taken from your account. Please try again.",
  "feature_sentiment_booking_journey_text": "Were you able to book easily?",
  "feature_sentiment_experience_text": "Let us know how your experience was today",

  "booking_login": "Log In",
  "booking_continue_guest": "Continue as Guest",
  "account_found": "Welcome back! We recognise this email, log in or continue as guest",
  "login_error": "Invalid email or password. Please try again.",
  "login_failed": "Login failed. Please try again.",
  "password": "Password",

  "decrement_guests": "Decrease number of guests",
  "increment_guests": "Increase number of guests",
  "minimum_guests_reached": "You reached the minimum number of guests set for this {{bookingType}}. You can contact {{venueName}} for more information",
  "maximum_guests_reached": "You reached the maximum number of guests for this {{bookingType}}. You can contact {{venueName}} for more information",
  "logging_in": "Logging in...",
  "login_section": "Account detected",
  "not_you": "Not you?",
  "logout": "Log out",
  "fixed_price_add_more": "This is a fixed price menu. Add {{count}} more item(s) for the same price!",
  "fixed_price_confirm_add_more": "Some of the fixed price menus added above will allow you to choose more items than you have currently selected, for the same price.",

  "sign_up": "Sign Up",
  "sign_up_password": "Create a password",
  "sign_up_prompt": "Create an account to earn reward points!",
  "sign_up_success": "Account created successfully!",
  "sign_up_error": "Sign up failed. Please try again.",
  "sign_up_section": "Create an account",

  "booking_offers_title": "Offers available",
  "booking_offers_question": "Would you like to add an offer to your booking?",
  "booking_offers_no_thanks": "No thanks",

  "interested_in_package": "Interested in a package?",
  "booking_select_package": "Select a package...",

  "booking_form_maximise": "Maximise booking form",
  "booking_form_restore": "Restore booking form",
  "booking_form_book_now": "Book now",
  "booking_form_dialog_label": "Booking form",
  "email_did_you_mean": "Did you mean"
}
